import { Button, Col, Container, Form, Row } from 'react-bootstrap'
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import ava from 'assets/images/demo-slider.svg'
import tickCircleIcon from 'assets/images/playroompage-tickCircle.svg'
import crossIcon from 'assets/images/playroompage-cross.svg'
import coinIcon from 'assets/images/coin.svg'
import invitePlayerIcon from 'assets/images/playroompage-waitplayer.svg'
import statusIcon from 'assets/images/playroompage-status.svg'
import arrowNextIcon from 'assets/images/angle-right-svgrepo-com.svg'
import avaDefault from 'assets/images/ava-default.jpeg'
import arrowBreadcrumbIcon from 'assets/images/playroom-breadcrumb-arrow.svg'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'
import iconDrop from 'assets/images/eventWater/iconDrop.png'
import iconSpin from 'assets/images/eventBoatRacing/iconSpin.png'
import iconWaterTank from 'assets/images/eventBunpimay/waterTank.png'
import iconBoat from 'assets/images/eventBoatRacingT10/iconBoat.png'
import iconLost from 'assets/images/eventBoatRacingT10/buon.png'
import {
	useEffect,
	useState,
	useContext,
	useRef,
	useCallback,
	useMemo,
} from 'react'
import { useAtom } from 'jotai'
import { mobilePageTitleAtom } from 'config/store'
import { FindRoomSVG } from 'assets/svg/RoomPageSVG/FindroomSVG'
import InviteFriendModal from 'components/Modal/InviteFriendModal'
import { SocketContext } from 'utils/socket'
import { useQuery } from 'react-query'
import {
	getCheckEventBoatRacingQuery,
	getCheckEventBunpimayQuery,
	getCheckEventWaterQuery,
	getRoomDetailOfGameQuery,
	useCheckStartGame,
	useCheckSub,
} from 'dataLayer/game'
import { getData, getLanguage, getUserinfo, setData } from 'utils/localStorage'
import { PATHS } from 'config/routes'
import RankListMobile from 'pages/RankMobile/components/RankListMobile'
import { useDispatch } from 'react-redux'
import { showSnackbar } from 'store/actions'
import { handleFlyBoatRacing, handleFlyItem, handleFlyWater } from 'utils/helpers'
import NotificationModal from 'pages/Event/EventBoatRacingT10/components/NotificationModal'

let firstScrollEndChat = true
let pageComment = 1
let lastScroll = 0
let isScrollUp = false
let isLastPageComment = false
let enableScrollLoadMoreComment = true
let isLoadingMoreComment = false
let isScrollEndBoxChat = -1
let totalNewMessageChat = 0

function PlayRoomPage({ title }) {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)
	const isMobileXxl = useMediaQuery(`(max-width: ${mediaQueryPoint.xxl}px)`)
	const { gameId, roomId } = useParams()
	const navigate = useNavigate()
	const chatBoxRef = useRef(null)
	const textAreaRef = useRef(null)
	const [flagChat, setFlagChat] = useState(false)
	const [listCommentOnline, setListCommentOnline] = useState([])
	const [textComment, setTextComment] = useState('')
	const [isReady, setIsReady] = useState(false)
	const [isStarted, setIsStarted] = useState(false)
	const [userPlay, setUserPlay] = useState(null)
	const [hasFetchApi, setHasFetchApi] = useState(false)
	const [dataStartGame, setDataStartGame] = useState(null)
	const userInfo = getUserinfo()
	const language = getLanguage()
	const {
		data: eventWater,
		isLoading: isLoadingEvent,
		refetch: refetchEvent,
	} = useQuery(getCheckEventWaterQuery())

	const {
		data: eventBoatRacing,
		isLoading: isLoadingEventBoatRacing,
		refetch: refetchEventBoatRacing,
	} = useQuery(getCheckEventBoatRacingQuery())
	const { data: eventBunpimay, refetch: refetchEventBunpimay } = useQuery(
		getCheckEventBunpimayQuery(),
	)
	if (!userInfo) navigate(PATHS.HOME_PAGE)

	let location = useLocation()
	const { socket, setSocketRoomId } = useContext(SocketContext)
	const [openModalWinLostT102025, setOpenModalWinLostT102025] = useState(false)
	const [openModalWinT102025, setOpenModalWinT102025] = useState(false)
	const [openModalLostT102025, setOpenModalLostT102025] = useState(false)
	const [numberBoat, setNumberBoat] = useState()
	const [dataCheckSub, setDataCheckSub] = useState()

	const { mutate: checkSub } = useCheckSub(data => {
		if (data?.responseCode === '200') {
			setDataCheckSub(data?.data)
		}
	})

	useEffect(() => {
		openModalWinLostT102025 && checkSub({ location: 'HOME', from: 'auto' })
	}, [openModalWinLostT102025])

	// useEffect(() => {
	// 	alert('page change ' + location.pathname)
	// }, [location])
	const { data, isLoading, refetch, isFetching } = useQuery(
		getRoomDetailOfGameQuery(gameId),
	)
	// console.log('PlayRoomPage:', isFetching, isLoadingMoreComment, data)

	const [, setMobilePageTitle] = useAtom(mobilePageTitleAtom)
	useEffect(() => {
		setMobilePageTitle(title)
		let listComment = []
		let timout

		isLoadingMoreComment = true
		socket.emit('get comment', { room_id: gameId, time: 1, pageComment: 1 })
		socket.on('get comment success', comments => {
			isLoadingMoreComment = false
			setTimeout(() => {
				enableScrollLoadMoreComment = true
			}, 450)
			if (comments.length < 20) isLastPageComment = true
			if (pageComment === 1) listComment = comments
			else listComment = [...comments, ...listComment]
			setListCommentOnline([...listComment])
		})

		socket.on('send comment success', function (data) {
			console.log('send comment success:', data)
			console.log('textAreaRef:', textAreaRef)
			let chatBoxInput = document.getElementById('inputChat')
			chatBoxInput.value = ''
			// textAreaRef.current.innerText = ''
			// setTextComment("");
			listComment.push(data)
			setListCommentOnline([...new Set(listComment)])
			scrollToBottomChat()
		})
		socket.on('add comment', function (data) {
			listComment.push(data)
			// setListCommentOnline([...listComment])
			setListCommentOnline([...new Set(listComment)])
			if (!isScrollEndBoxChat) {
				totalNewMessageChat = totalNewMessageChat + 1
			} else {
				scrollToBottomChat()
			}
		})

		socket.on('blocked', function (message) {
			// alert(message)
		})

		socket.on('send comment error', data => {
			dispatch(
				showSnackbar(true, data.message || "Can't send comment!", 'error'),
			)
		})

		socket.on('ready toggle success', data => {
			setIsReady(data.status ? true : false)
		})

		socket.on('ready toggle success room', data => {
			setIsReady(data.status ? true : false)
		})

		socket.on('kick user success', data => {
			refetch()
			setUserPlay(null)
			setIsReady(false)
		})

		socket.on('kick user error', message => {
			dispatch(showSnackbar(true, message || "Can't kick user!", 'error'))
		})
		socket.on('kick user success to room', () => {
			navigate(PATHS.HOME_PAGE)
			setSocketRoomId(0)
		})
		socket.on('cant join room', () => {
			document.body.classList.remove('disable-scroll')
			navigate(PATHS.HOME_PAGE)
			setSocketRoomId(0)
		})

		socket.on('user join you room', () => {
			refetch()
			closeInviteFriendModal()
		})

		socket.on('player leave room success', () => {
			refetch()
		})

		socket.on('leave room success to room', () => {
			navigate(PATHS.HOME_PAGE)
			setSocketRoomId(0)
		})

		socket.on('start game success', data => {
			document.body.classList.add('disable-scroll')
			if (eventWater?.is_show) {
				document.getElementById('icon-event')?.classList.add('none')
			}
			if (eventBoatRacing?.is_show) {
				document.getElementById('icon-event-boat-racing')?.classList.add('none')
			}
			if (eventBunpimay?.is_show) {
				document.getElementById('icon-event-bunpimay')?.classList.add('none')
			}
			setDataStartGame(data)
			setIsStarted(true)
		})

		// event T10 2025
		socket.on('boat_racing_game', data => {
			if (!data?.is_sub) {
				// chưa mua gói
				setOpenModalWinLostT102025(true);
			} else if (data?.is_win) {
				// có gói + thắng
				setNumberBoat(data?.boat);
				setOpenModalWinT102025(true);
			} else {
				// có gói + thua
				setNumberBoat(data?.boat || 1);
				setOpenModalLostT102025(true);
			}
		})

		socket.on('start game error', message => {
			dispatch(showSnackbar(true, message || "Can't start game!", 'error'))
		})

		socket.on('check start game error', () => {
			document.body.classList.remove('disable-scroll')
			if (eventWater?.is_show) {
				document.getElementById('icon-event')?.classList.remove('none')
			}
			if (eventBoatRacing?.is_show) {
				document.getElementById('icon-event-boat-racing')?.classList.remove('none')
			}
			if (eventBunpimay?.is_show) {
				document.getElementById('icon-event-bunpimay')?.classList.remove('none')
			}
			setIsStarted(false)
		})

		// socket.on('end game', data => {
		// 	if (eventWater?.is_show && !eventWater?.is_finished && isStarted) {
		// 		let checkUserWinGame = data.users?.find(
		// 			it => it.user_id == userInfo.userId && it.result == 1,
		// 		)
		// 		let checkShowWater = getData('list-user-play')?.length
		// 		if (checkUserWinGame && !checkShowWater) {
		// 			handleFlyWater(iconDrop)
		// 			setData('list-user-play', data.users)
		// 		}
		// 	}
		// })

		socket.on('back to room', data => {
			data?.game_error == 1 &&
				dispatch(showSnackbar(true, t('room.playroom.error_game'), 'error'))
			document.body.classList.remove('disable-scroll')

			setIsStarted(false)
			if (eventWater?.is_show) {
				document.getElementById('icon-event')?.classList?.remove('none')
			}

			if (eventWater?.is_show && !eventWater?.is_finished) {
				let checkUserWinGame = data.users?.find(
					it =>
						it.user_id == userInfo.userId &&
						it.result == 1 &&
						it.is_disconnect != true,
				)
				let checkShowWater = getData('list-user-play')?.length
				if (checkUserWinGame && !checkShowWater) {
					handleFlyWater(iconDrop)
					setData('list-user-play', data.users)
					timout = setTimeout(() => {
						setData('list-user-play', [])
					}, 7000)
				}
			}

			if (eventBoatRacing?.is_show) {
				document
					.getElementById('icon-event-boat-racing')
					?.classList.remove('none')
			}

			if (eventBoatRacing?.is_show && !eventBoatRacing?.is_finished) {
				let checkUserWinGame = data.users?.find(
					it =>
						it.user_id == userInfo.userId &&
						it.result == 1 &&
						it.is_disconnect != true,
				)
				let checkShowBoatRacing = getData('list-user-play')?.length
				if (checkUserWinGame && !checkShowBoatRacing) {
					handleFlyBoatRacing(iconSpin, 1)
					setData('list-user-play', data.users)
					timout = setTimeout(() => {
						setData('list-user-play', [])
					}, 7000)
				}
			}
			if (eventBunpimay?.is_show) {
				document
					.getElementById('icon-event-bunpimay')
					.classList.remove('none')
			}
			if (eventBunpimay?.is_show && !eventBunpimay?.is_finished) {
				handleFlyItem(iconWaterTank, 'icon-event-bunpimay', 'show-item-fly')
			}

			refetch()
		})

		socket.on('back to game', data => {
			document.body.classList.remove('disable-scroll')
			console.log(data)

			setIsStarted(false)
			navigate(PATHS.ROOM_PAGE.replace(':roomId', data.game_id))
			if (eventWater?.is_show) {
				document.getElementById('icon-event').classList.remove('none')
			}

			if (eventWater?.is_show && !eventWater?.is_finished) {
				let checkUserWinGame = data.users?.find(
					it =>
						it.user_id == userInfo.userId &&
						it.result == 1 &&
						it.is_disconnect != true,
				)
				let checkShowWater = getData('list-user-play')?.length
				if (checkUserWinGame && !checkShowWater) {
					handleFlyWater(iconDrop)
					setData('list-user-play', data.users)
					timout = setTimeout(() => {
						setData('list-user-play', [])
					}, 7000)
				}
			}

			if (eventBoatRacing?.is_show) {
				document
					.getElementById('icon-event-boat-racing')
					?.classList.remove('none')
			}

			if (eventBoatRacing?.is_show && !eventBoatRacing?.is_finished) {
				let checkUserWinGame = data.users?.find(
					it =>
						it.user_id == userInfo.userId &&
						it.result == 1 &&
						it.is_disconnect != true,
				)
				let checkShowBoatRacing = getData('list-user-play')?.length
				if (checkUserWinGame && !checkShowBoatRacing) {
					handleFlyBoatRacing(iconSpin, 1)
					setData('list-user-play', data.users)
					timout = setTimeout(() => {
						setData('list-user-play', [])
					}, 7000)
				}
			}
			if (eventBunpimay?.is_show) {
				document
					.getElementById('icon-event-bunpimay')
					.classList.remove('none')
			}
			if (eventBunpimay?.is_show && !eventBunpimay?.is_finished) {
				handleFlyItem(iconWaterTank, 'icon-event-bunpimay', 'show-item-fly')
			}
			setSocketRoomId(0)
		})
		return () => {
			clearTimeout(timout)
		}
	}, [])

	const [modalInviteFriend, setModalInviteFriend] = useState(false)

	function openInviteFriendModal() {
		setModalInviteFriend(true)
	}
	function closeInviteFriendModal() {
		setModalInviteFriend(false)
	}

	useEffect(() => {
		if (data !== undefined && data.room !== undefined) {
			if (data.room.users.length > 0) setSocketRoomId(gameId)
			if (data.room.users.length === 2) {
				setUserPlay(data.room.users[1])
				if (data.room.status === 1) {
					if (data.room.users[1].state) setIsReady(true)
					else if (data.room.status === 1) setIsReady(false)
				}
			} else if (data.room.users.length === 1) {
				if (userInfo.userId != data.room.users[0].id) {
					setUserPlay(null)
					setSocketRoomId(0)
					navigate(PATHS.ROOM_PAGE.replace(':roomId', data.room.game_id))
				} else if (data.room.status === 1) {
					setIsReady(false)
				}
			} else if (data.room.users.length <= 0 && !isStarted) {
				setSocketRoomId(0)
				navigate(PATHS.ROOM_PAGE.replace(':roomId', data.room.game_id))
			}
		} else if (!isFetching && data === undefined && !isStarted) {
			setSocketRoomId(0)
			navigate(PATHS.ROOM_PAGE.replace(':roomId', roomId))
		}
	}, [data, isFetching, isLoading])
	// TODO: Implement kick player feature (popup confirm to remove player)

	const _checkStartGameSuccess = result => {
		if (!result.status) {
			dispatch(
				showSnackbar(true, result.message || "Can't start game!", 'error'),
			)
		} else {
			// setIsStarted(true);
			socket.emit('start game')
		}
	}
	const { mutate, isLoading: isLoadingCheckStart } = useCheckStartGame(
		_checkStartGameSuccess,
	)

	const onPressPlayGameStart = () => {
		if (socket && socket.connected && !isStarted && userPlay) {
			socket.emit('start game')
			// mutate({
			// 	game_id: roomId,
			// 	room_id: gameId,
			// 	users: [data.room.users[0].id, userPlay.id],
			// })
		}
	}

	const onPressKickUser = user_id => {
		if (socket && socket.connected && userInfo.userId == data.room.owner_id) {
			socket.emit('kick user', { user_id })
		}
	}

	const onPressReadyToggle = () => {
		if (socket && socket.connected) {
			socket.emit('ready toggle', { status: !isReady })
		}
	}

	const sendComment = () => {
		let comment = textAreaRef.current.value.trim()
		if (comment) {
			if (socket && socket.connected) {
				socket.emit('send comment', comment)
			} else {
			}
		} else {
			textAreaRef.current && textAreaRef.current.focus()
		}
	}
	const checkEnterChat = event => {
		if (event.keyCode === 13 && !event.shiftKey) {
			event.preventDefault()
			event.stopPropagation()
			sendComment()
		}
	}
	const onChangeHandler = event => {
		setTextComment(event.target.value.trim())
	}

	useEffect(() => {
		if (listCommentOnline.length > 0) {
			if (firstScrollEndChat) {
				firstScrollEndChat = false
				scrollToBottomChat()
			} else if (isScrollEndBoxChat) {
				totalNewMessageChat = 0
				scrollToBottomChat()
			}
		}
	}, [listCommentOnline])

	const scrollToBottomChat = () => {
		var boxChat = document.getElementById('chat-wrapper')
		if (boxChat) {
			setFlagChat(!flagChat)
			totalNewMessageChat = 0
			boxChat.scroll({ top: boxChat.scrollHeight, behavior: 'smooth' })
		}
	}

	const handleScroll = useCallback(() => {
		const { scrollTop, scrollHeight, clientHeight } = chatBoxRef.current
		isScrollEndBoxChat = 0
		isScrollUp = false
		if (scrollTop < lastScroll) {
			isScrollUp = true
		}

		if (scrollTop + clientHeight === scrollHeight) {
			// TO SOMETHING HERE
			isScrollEndBoxChat = 1
		} else if (
			scrollTop <= 50 &&
			isScrollUp &&
			!isLastPageComment &&
			enableScrollLoadMoreComment
		) {
			if (socket && socket.connected) {
				isLoadingMoreComment = true
				enableScrollLoadMoreComment = false
				pageComment = pageComment + 1
				socket.emit('get comment', { room_id: gameId, time: 1, pageComment })
			}
		}
		// console.warn('scrolling:',isScrollEndBoxChat,isScrollUp,scrollTop,scrollHeight,clientHeight);
		lastScroll = scrollTop
	}, [])

	useEffect(() => {
		const div = chatBoxRef.current
		if (div) div.addEventListener('scroll', handleScroll)
	}, [chatBoxRef.current])

	let url_play_game = ``
	if (data && dataStartGame) {
		url_play_game = `${data.room.game_url}/?token=token_user`
		if (data.room.owner_id == userInfo.userId) {
			url_play_game = url_play_game.replace('token_user', dataStartGame.token1)
		} else {
			url_play_game = url_play_game.replace('token_user', dataStartGame.token2)
		}
	}
	return (
		<>
			{!isStarted ? (
				<>
					<Container fluid className="playroom-container">
						{isMobileMD ? null : (
							<Row className="breadcrumb mt-4">
								<div className="back-to-roompage">
									<FindRoomSVG width="16" height="16" viewBox="0 0 16 16" />
									<Link
										to={PATHS.ROOM_PAGE.replace(':roomId', roomId)}
										replace
										state={{ previous: location.pathname }}
									>
										{t('room.playroom.find_room')}
									</Link>
								</div>
								<img src={arrowBreadcrumbIcon} width="5" height="9" alt="" />
								<p>{t('room.playroom.title')}</p>
							</Row>
						)}
						{data && data.room.users.length > 0 && (
							<Row className="readyscreen-container">
								<Row className="text-center">
									<Col
										xs={4}
										className="d-flex flex-column align-items-center justify-content-between"
									>
										<div className="ava-frame">
											<img
												src={data.room.users[0].avatarImage || avaDefault}
												alt="User'avatar"
											/>
										</div>
										<div className="d-flex mt-2 align-items-center">
											{data.room.users[0].state === 1 && (
												<img
													src={tickCircleIcon}
													width="27"
													height="27"
													className="me-2"
													alt="User's status"
												/>
											)}
											<p className="user-name">
												{data.room.users[0].full_name}
											</p>
										</div>
										<div className="bet-box d-flex justify-content-center align-items-center mt-2">
											<img src={coinIcon} alt="User's bet" className="me-2" />
											<p>
												{new Intl.NumberFormat('lo').format(
													data.room.users[0].coin,
												)}
											</p>
										</div>
									</Col>
									<Col
										xs={4}
										className="readyscreen-status d-flex flex-column align-items-center"
									>
										<p>
											{t('room.table.id')}: {gameId}
										</p>
										<img
											src={statusIcon}
											width={isMobileMD ? '115' : '130'}
											height={isMobileMD ? '115' : '130'}
											alt="Playroom's status"
										/>
										<p>
											{new Intl.NumberFormat('lo').format(data.room.coin)} Gold
										</p>
										{isMobileMD ? null : userInfo.userId ==
											data.room.owner_id ? (
											<Button
												variant="primary"
												className="mt-3"
												onClick={onPressPlayGameStart}
												disabled={!isReady}
											>
												{t('room.playroom.start')}
											</Button>
										) : (
											<Button
												variant="secondary"
												className="start-mobile ready mt-3"
												onClick={onPressReadyToggle}
											>
												{t(
													!isReady
														? 'room.playroom.ready'
														: 'room.playroom.unready',
												)}
											</Button>
										)}
									</Col>
									<Col
										xs={4}
										className="d-flex flex-column align-items-center justify-content-between"
									>
										{data.room.users[1] === undefined ? (
											<Button
												className="ava-frame dark-bg"
												onClick={openInviteFriendModal}
											>
												<img
													src={invitePlayerIcon}
													className="invite-player"
													alt="Invite player"
												/>
											</Button>
										) : (
											<>
												<div className="ava-frame">
													<img
														src={data.room.users[1].avatarImage || avaDefault}
														alt="User'avatar"
													/>
												</div>
												<div className="d-flex mt-2 align-items-center">
													{isReady && (
														<img
															src={tickCircleIcon}
															width="27"
															height="27"
															className="me-2"
															alt="Player's status"
														/>
													)}
													<p className="user-name">
														{data.room.users[1].full_name}
													</p>
												</div>
												<div className="bet-box d-flex justify-content-center align-items-center mt-2">
													<img
														src={coinIcon}
														width={20}
														height={20}
														alt="User's bet"
														className="me-2"
													/>
													<p>
														{new Intl.NumberFormat('lo').format(
															data.room.users[1].coin,
														)}
													</p>
												</div>
											</>
										)}
									</Col>
									{data.room.users[1] !== undefined &&
										userInfo.userId == data.room.owner_id && (
											<Row className="mt-2 mx-0 px-0 mt-md-4">
												<Col
													xs={{ span: 4, offset: 8 }}
													className="justify-content-center"
												>
													<img
														src={crossIcon}
														onClick={() =>
															onPressKickUser(data.room.users[1].id)
														}
														width="27"
														height="27"
														className="mx-auto"
														style={{ cursor: 'pointer' }}
														alt="Kick player"
													/>
												</Col>
											</Row>
										)}
									{isMobileMD ? (
										userInfo.userId == data.room.owner_id ? (
											<Button
												variant="primary"
												className="start-mobile mt-3"
												onClick={onPressPlayGameStart}
											>
												{t('room.playroom.start')}
											</Button>
										) : (
											<Button
												variant="secondary"
												className="start-mobile ready mt-3"
												onClick={onPressReadyToggle}
											>
												{t(
													!isReady
														? 'room.playroom.ready'
														: 'room.playroom.unready',
												)}
											</Button>
										)
									) : null}
								</Row>
								<Row className="chat-container">
									<div
										className="chat-container-body"
										id="chat-wrapper"
										ref={chatBoxRef}
									>
										<div
											className={`chat-container-body-content ${listCommentOnline.length <= 4 ? 'full-height' : ''
												}`}
										>
											{listCommentOnline.length > 0 &&
												listCommentOnline.map((itemChat, index) => {
													return (
														<div
															className="line-chat"
															id={`item_chat_${itemChat._id}`}
															key={`item_chat_${itemChat._id}_${itemChat.created_at}_${index}`}
														>
															<span
																className={`line-chat-name ${itemChat.user_id == userInfo.userId
																	? 'owner'
																	: ''
																	}`}
															>
																{itemChat.fullname}:
															</span>
															<span className="line-chat-content">
																{itemChat.comment}
															</span>
														</div>
													)
												})}
										</div>
									</div>
									<Form>
										<Form.Group>
											<Form.Control
												type="text"
												placeholder={t('room.playroom.enter_text')}
												ref={textAreaRef}
												onKeyDown={e => checkEnterChat(e)}
												id="inputChat"
											// onChange={onChangeHandler}
											// value={textComment}
											/>
										</Form.Group>
									</Form>
									<Button
										variant="primary"
										onClick={sendComment}
										className="send-chat"
									>
										<img src={arrowNextIcon} alt="Send chat" />
									</Button>
								</Row>
							</Row>
						)}
					</Container>
					{modalInviteFriend && (
						<InviteFriendModal
							show={modalInviteFriend}
							onHide={closeInviteFriendModal}
							roomId={gameId}
						/>
					)}

					{/* Khi thắng/thua mà chưa có gói */}
					<NotificationModal
						show={openModalWinLostT102025}
						title={t('event.event_boa_racing_t10.notice')}
						content={t('event.event_boa_racing_t10.you_need_to_subscribe_to_the_dailysub_package_to_participate_in_the_boun_suang_heua_event_and_receive_many_valuable_rewards')}
						footer={
							<>
								<button onClick={() => navigate('/event-boat-racing')} className='button-event'>
									<img src={iconBoat} alt="iconBoat" className='icon-boat-event' />
									{t('event.event_boa_racing_t10.visit_event')}
								</button>
								<button onClick={() => {
									if (dataCheckSub?.urlWebView) {
										window.location.href = dataCheckSub?.urlWebView;
									}
								}}
									className='button-continue'>
									{t('event.event_boa_racing_t10.buy_package')}
								</button>
							</>}
						handleCancel={() => setOpenModalWinLostT102025(false)}
					/>
					{/* Khi thắng mà đã có gói */}
					<NotificationModal
						show={openModalWinT102025}
						title={t('event.event_boa_racing_t10.congratulations')}
						content={
							<>
								<Trans
									i18nKey="event.event_boa_racing_t10.you_have_received_3x_number_from_your_recent_victory_please_visit_the_event_page_to_view_the_reward_details"
									values={{ count: numberBoat }}
									components={[<img src={iconBoat} alt="iconBoat" className="icon-boat" />]}
								/>
							</>}
						footer={
							<>
								<button onClick={() => navigate('/event-boat-racing')} className='button-event'>
									<img src={iconBoat} alt="iconBoat" className='icon-boat-event' />
									{t('event.event_boa_racing_t10.visit_event')}
								</button>
								<button onClick={() => setOpenModalWinT102025(false)} className='button-continue'>
									{t('event.event_boa_racing_t10.continue')}
								</button>
							</>}
						handleCancel={() => setOpenModalWinT102025(false)}
					/>
					{/* Khi thua mà đã có gói */}
					<NotificationModal
						show={openModalLostT102025}
						title={<img src={iconLost} alt="iconBoat" className="icon-boat" height={55} width={55} />}
						content={
							<>
								<Trans
									i18nKey="event.event_boa_racing_t10.you_lost_this_round_but_you_still_receive_1x_number_keep_competing_glory_is_still_waiting_for_you"
									values={{ count: numberBoat }}
									components={[<img src={iconBoat} alt="iconBoat" className="icon-boat" />]}
								/>
							</>
						}
						footer={
							<>
								<button onClick={() => navigate('/event-boat-racing')} className='button-event'>
									<img src={iconBoat} alt="iconBoat" className='icon-boat-event' />
									{t('event.event_boa_racing_t10.visit_event')}
								</button>
								<button onClick={() => setOpenModalLostT102025(false)} className='button-continue'>
									{t('event.event_boa_racing_t10.continue')}
								</button>
							</>}
						handleCancel={() => setOpenModalLostT102025(false)}
					/>
				</>
			) : isMobileMD || isMobileXxl ? (
				<iframe
					id="game-play"
					title="PlayGame"
					className="playroom-game isMobileMD"
					src={url_play_game}
				></iframe>
			) : (
				<div className="container-playroom">
					<div className="container-playroom-content">
						<div className="playroom-game_box">
							<iframe
								id="game-play"
								title="PlayGame"
								className="playroom-game"
								src={url_play_game}
							></iframe>
						</div>

						<div className="playroom-game-rank">
							<RankListMobile playGame={true} />
						</div>
					</div>
				</div>
			)
			}
		</>
	)
}

export default PlayRoomPage
